export default "__VITE_ASSET__Bv56b1$s__"